<template>
  <div class="empty-pages-list" v-if="hasArchived">
    <img class="empty-pages-list__icon" :src="$vuetify.theme.dark ? emptyListDarkImg : emptyListLightImg" />
    <div class="empty-pages-list__title">{{ $t("resources.pages.empty_list_title_has_archived") }}</div>
    <div class="empty-pages-list__subtitle">{{ $t("resources.pages.empty_list_subtitle_has_archived") }}</div>
    <div class="empty-pages-list__create">
      <v-btn v-if="listState.excludedItemsCount" color="primary" class="mr-4" outlined @click="filterArchivedPages">
        {{ $t("custom.empty_list.show_archived", { count: listState.excludedItemsCount }) }}
      </v-btn>
      <v-btn color="primary" class="left-icon" :to="route">
        <plus-icon class="fill--same-white mr-2"></plus-icon>
        {{ $t("custom.empty_list.create") }}
      </v-btn>
    </div>
  </div>
  <empty-list
    v-else
    :list-page="listPage"
    :title="listPage ? $t('resources.pages.list_page_empty_list_title') : $t('resources.pages.empty_list_title')"
    :route="listPage ? { name: 'pages_create' } : { name: 'pages_create', query: { domainId } }">
    <template #subtitle v-if="listPage">
      {{ $t("resources.pages.list_page_empty_list_subtitle_1") }}
      <a href="https://help.siterunner.com/help/pages-how-to-create-a-page" target="_blank" class="help-link">{{
        $t("resources.pages.list_page_empty_list_subtitle_link")
      }}</a>
      {{ $t("resources.pages.list_page_empty_list_subtitle_2") }}
    </template>
    <template #subtitle v-else>
      {{ $t("resources.pages.empty_list_subtitle") }}
    </template>
  </empty-list>
</template>

<script>
  import EmptyList from "@/components/custom/EmptyList";

  import emptyListLightImg from "@/assets/images/empty-list/generic-empty-list-light.png";
  import emptyListDarkImg from "@/assets/images/empty-list/generic-empty-list-dark.png";

  import PlusIcon from "@/components/icons/PlusIcon";

  export default {
    name: "EmptyPagesList",
    components: {
      PlusIcon,
      EmptyList,
    },
    props: {
      /**
       * Different UI for when the empty resource list is displayed inside a resource list page and single domain view.
       */
      listPage: {
        type: Boolean,
        default: false,
      },
      domainId: {
        type: String,
        default: "",
      },
      listState: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        emptyListLightImg,
        emptyListDarkImg,
        route: {},
      };
    },
    computed: {
      hasArchived() {
        return this.listState.excludedItemsCount > 0;
      },
    },
    beforeMount() {
      this.route = this.listPage
        ? { name: "pages_create" }
        : { name: "pages_create", query: { domainId: this.domainId } };
    },
    methods: {
      filterArchivedPages() {
        this.$emit("filterArchivedPages");
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/typography/index.scss";
  @import "../../@core/preset/preset/functions.scss";

  .empty-pages-list {
    background-color: get-color("element-bg-100");
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 112.5px 0;
    border-top: 1px solid get-color("border");
    &__icon {
      margin-bottom: 8px;
    }
    &__title {
      @include heading-4();
      color: get-color("headline");
    }
    &__subtitle {
      margin-bottom: 24px;
      @include text-subtitle-2();
      color: get-color("subtitle");
      max-width: 460px;
      text-align: center;
    }
  }
</style>
